import { ReactNode, useEffect, useState } from 'react';
import { Message, Icon } from 'semantic-ui-react';
import { ProjectRejectionReason, ProjectRejectionReasons } from '~/constants';
import { useProjectContext } from '~/hooks';
import '../styles.scss';

export default function ErrorDialog() {
  const { project, projectState } = useProjectContext();
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    // Relevant for when the dialog has been previously closed 
    setIsDismissed(false);
  }, [projectState.dealState]);

  const error = {
    title: '',
    message: '' as ReactNode
  };

  error.title = 'Project returned to draft status';

  const reason = ProjectRejectionReasons[project?.rejectionDetail?.reason as ProjectRejectionReason];
  const messageParts = project?.rejectionDetail?.message?.split('\n');

  if (reason || messageParts?.length) {
    error.message = (
      <>
        {reason ? <p>{reason}</p> : null}
        {messageParts?.length ? (
          messageParts.map((part: string, i: number) => (
            <p key={i}>{part}</p>
          ))
        ) : null}
      </>
    );
  }

  return !isDismissed && error.title && error.message
    ? (
      <Message error icon style={{ display: 'flex', alignItems: 'center', width: '100%', marginTop: '12px', marginBottom: '12px' }}>
        <Icon name="exclamation circle" style={{ fontSize: '32px' }} />
        <div>
          <Message.Header>{error.title}</Message.Header>
          <Message.Content>{error.message}</Message.Content>
        </div>
      </Message>
    )
    : null;
}